import { useEffect, useRef } from 'react';

import { emitToHost } from '../lib/bridge.js';

/**
 * Relay the unread-chats count (see `UNREAD_CHATS_QUERY`) to the host as
 * `unread-count`. Only a change travels: `null` is "not answered yet", and a
 * repeat would redraw the host badge with a number another surface may have
 * already corrected (the panel relays live while the launcher's poll pauses).
 */
export function useHostUnread(n: number | null): void {
  const sent = useRef<number | null>(null);
  useEffect(() => {
    if (n === null || n === sent.current) return;
    sent.current = n;
    emitToHost('unread-count', { n });
  }, [n]);
}
